type EnvironmentType = "development" | "test" | "staging" | "production";

function getEnvironment(): EnvironmentType {
  const hostname = window.location.hostname.toLowerCase();

  if (hostname.includes("localhost")) {
    return "development";
  } else if (hostname.includes("test") || hostname.includes("testing")) {
    return "test";
  } else if (hostname.includes("staging")) {
    return "staging";
  } else if (process.env.NODE_ENV === "production") {
    return "production";
  }

  // fallback for unknown hostnames
  return "development";
}

const currentEnv = getEnvironment();

export const Environment = {
  current: currentEnv,
  isDevelopment: currentEnv === "development",
  isTest: currentEnv === "test",
  isStaging: currentEnv === "staging",
  isProduction: currentEnv === "production",
};
